// extracted by mini-css-extract-plugin
export default {"safe__Button":"Button_safe__Button__WQpJM","buttontext":"Button_buttontext__yEfXG"};